import type { Resume } from "@adafia/types";
import { fetchWithAuth } from "@adafia/ui";

const API_BASE = "/api/v1/resumes";

export const getResumes = async (): Promise<Resume[]> => {
	const res = await fetchWithAuth(API_BASE);
	if (!res.ok) throw new Error("Failed to fetch resumes");
	return res.json();
};

export const getResumeBySlug = async (slug: string): Promise<Resume> => {
	const res = await fetchWithAuth(`${API_BASE}/slug/${slug}`);
	if (!res.ok) throw new Error("Failed to fetch resume");
	return res.json();
};

export const getPublicResumeBySlug = async (slug: string): Promise<Resume> => {
	const res = await fetch(`${API_BASE}/public/${slug}`);
	if (!res.ok) throw new Error("Failed to fetch public resume");
	return res.json();
};

export const updateResume = async (
	id: string,
	data: Partial<Resume>,
): Promise<Resume> => {
	const res = await fetchWithAuth(`${API_BASE}/${id}`, {
		method: "PATCH",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(data),
	});
	if (!res.ok) throw new Error("Failed to update resume");
	return res.json();
};

export const createResume = async (
	data: Omit<Resume, "id" | "createdAt" | "updatedAt">,
): Promise<Resume> => {
	const res = await fetchWithAuth(API_BASE, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(data),
	});
	if (!res.ok) throw new Error("Failed to create resume");
	return res.json();
};

export const deleteResume = async (id: string): Promise<void> => {
	const res = await fetchWithAuth(`${API_BASE}/${id}`, {
		method: "DELETE",
	});
	if (!res.ok) throw new Error("Failed to delete resume");
};
